import { render, staticRenderFns } from "./keenMind.vue?vue&type=template&id=38920e33&"
import script from "./keenMind.vue?vue&type=script&lang=js&"
export * from "./keenMind.vue?vue&type=script&lang=js&"
import style0 from "./keenMind.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports